// @flow
import { CHECKLIST } from 'Client/cms/toolkit/constants';
import { ChecklistLine } from 'Components/lines/checklist-line/ChecklistLine.jsx';

export const checklistDescriptor = {
  name: CHECKLIST,
  component: ChecklistLine,
};
